import React, { Component, Fragment } from 'react';
import { withRouteData } from 'react-static';
import * as R from 'ramda';

import Head from '../components/Head';
import HomeScreen from '../components/HomeScreen';

import withAppProvider from '../providers/App';
import { key } from '../i18n/react';
import { HttpService } from '../services';
import { renameKeys } from '../helpers';

import '../styles/main.scss';

class Home extends Component {
  state = {
    articlesData: {},
    videosData: {},
  };

  fetchArticles = async (pageNum = 1) => {
    const {
      data: { MsLandingArticleList, PageCount, PageNum },
    } = await HttpService.client.get('/Information/MsLanding/GetArticleList', {
      params: {
        PageNum: pageNum,
        PageSize: 4,
      },
    });

    return {
      items: [
        ...R.map(
          item =>
            renameKeys({
              Id: 'id',
              Title: 'title',
              Content: 'content',
              ImageSrc: 'imageSrc',
              PublishedDateTimeUtc: 'date',
            })(item),
          MsLandingArticleList,
        ),
      ],
      pageCount: PageCount,
      pageNum: PageNum,
    };
  };

  fetchVideos = async (pageNum = 1) => {
    const {
      data: { MsLandingVideoList, PageCount, PageNum },
    } = await HttpService.client.get('/Information/MsLanding/GetVideoList', {
      params: {
        PageNum: pageNum,
        PageSize: 50,
      },
    });

    return {
      items: R.map(
        item =>
          renameKeys({
            Id: 'id',
            Title: 'title',
            VideoSrc: 'videoSrc',
            ImageSrc: 'imageSrc',
            PublishedDateTimeUtc: 'date',
          })(item),
        MsLandingVideoList,
      ),
      pageCount: PageCount,
      pageNum: PageNum,
    };
  };

  fetchMore = async ({ propName, fetch }) => {
    const { items, pageNum, pageCount } = this.state[propName];

    if (pageNum >= pageCount) {
      return;
    }

    const nextPageNum = pageNum + 1;
    const fetchedData = await fetch(nextPageNum);

    this.setState(state => ({
      ...state,
      [propName]: {
        ...state[propName],
        items: [...items, ...fetchedData.items],
        pageNum: nextPageNum,
      },
    }));
  };

  fetchMoreArticles = async () =>
    this.fetchMore({
      propName: 'articlesData',
      fetch: this.fetchArticles,
    });

  fetchMoreVideos = async () =>
    this.fetchMore({
      propName: 'videosData',
      fetch: this.fetchVideos,
    });

  async componentDidMount() {
    HttpService.setAcceptLanguage(this.props.lang);

    const articlesData = await this.fetchArticles();
    const videosData = await this.fetchVideos();

    this.setState(state => ({
      ...state,
      articlesData,
      videosData,
    }));
  }

  render() {
    const { lang, messages, rootUrl } = this.props;
    const { articlesData, videosData } = this.state;
    const t = k => key(k, messages[lang]);

    return (
      <Fragment>
        <Head title={t('home.windowTitle')} />
        <HomeScreen
          lang={lang}
          rootUrl={rootUrl}
          articlesData={articlesData}
          videosData={videosData}
          t={t}
          fetchMoreArticles={this.fetchMoreArticles}
          fetchMoreVideos={this.fetchMoreVideos}
        />
      </Fragment>
    );
  }
}

export default withRouteData(withAppProvider(Home));



// WEBPACK FOOTER //
// /app/apps/ms/src/containers/Home.js